module.exports = __webpack_public_path__ + "static/media/kaminashi_header.1e568ea2.png";